import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetEnglishIqSupplyV1Response } from './get-english-iq-supply-v1-response';
import { getEnglishIqSupplyV1ResponseSchema } from './get-english-iq-supply-v1-response';

export async function getEnglishIqSupplyV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetEnglishIqSupplyV1Response>> {
  return getRequest<IGetEnglishIqSupplyV1Response>({
    options,
    path: '/sys/english-iq/supply/v1',
    schema: getEnglishIqSupplyV1ResponseSchema,
  });
}
